import React, { PureComponent } from 'react';

import './AppBarOther.css'

class AppBarOther extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      showDescription: false,
    };
  }

  getIcon(name) {
    switch (name) {
      case 'portfolio-analysis':
        return 'Money.svg'
      case 'performance-at-a-glance':
        return 'Line-Chart.svg'
      case 'dailyperf':
        return 'arrow-right.svg'
      case 'shortlevfaq':
        return 'Sun.svg'
      case 'ecocal':
        return 'Pillow-Chart-1.svg'
      case 'shortlevsim':
        return 'Pillow-Chart-2.svg'
      default:
        return '';
    }
  }

  render() {
    const {
      title,
      description,
      name,
      activeApp,
      link,
    } = this.props;

    let appStyle = 'otherBarStyle';
    let columnClass = 'col-md-4';
    let iconHolderStyle = 'iconHolderStyle';
    let titleStyle = 'titleStyle';
    let aniStyle = 'aniStyle';
    let closeStyle = 'closeStyle';
    let iconStyle = 'iconStyle';

    return (
      <div className={columnClass + ' ' + aniStyle}>
        <div id={name + '-header'} className={appStyle} onClick={() => window.location.href = link}>
          {activeApp === name &&
            <div className={closeStyle}>&nbsp;</div>
          }
          {activeApp === '' &&
            <div className={closeStyle}>&nbsp;</div>
          }
          <div className={iconHolderStyle}><img className={iconStyle} src={`${process.env.REACT_APP_BASE_URL}/icons/${this.getIcon(name)}`} /></div>
          <div className={titleStyle}>{title}</div>
          {(activeApp !== name) &&
            <div className={'descriptionStyle'}>{description}</div>
          }
        </div>
      </div>
    );
  }
}

export default (AppBarOther);


// WEBPACK FOOTER //
// ./src/components/App/AppBarOther.js